// import React, { useEffect, useState } from 'react';
// import MemberLayout from '../../components/MemberLayout';
// import { getMyProfile, getMyCases, getMyMessages } from '../../services/api';
// import { useAuth } from '../../context/AuthContext';

// function StatusBadge({ status }) {
//   const cls = status === 'ACTIVE' ? 'badge-active' : status === 'EXPIRED' ? 'badge-expired' : 'badge-pending';
//   return <span className={`badge ${cls}`}>{status}</span>;
// }

// export default function Dashboard() {
//   const { user } = useAuth();
//   const [profile, setProfile] = useState(null);
//   const [cases, setCases] = useState([]);
//   const [messages, setMessages] = useState([]);

//   useEffect(() => {
//     getMyProfile().then((res) => setProfile(res.data)).catch(() => {});
//     getMyCases().then((res) => setCases(res.data)).catch(() => {});
//     getMyMessages().then((res) => setMessages(res.data)).catch(() => {});
//   }, []);

//   return (
//     <MemberLayout>
//       <h2>Welcome back, {profile?.fullName || user?.username}</h2>
//       <p style={{ marginBottom: 24 }}>Here's an overview of your membership and cases.</p>

//       <div className="grid grid-3" style={{ marginBottom: 32 }}>
//         <div className="card">
//           <div className="stat-label">Membership Number</div>
//           <div className="stat-number" style={{ fontSize: '1.4rem' }}>{profile?.membershipNumber || '—'}</div>
//         </div>
//         <div className="card">
//           <div className="stat-label">Status</div>
//           <div style={{ marginTop: 8 }}>{profile ? <StatusBadge status={profile.status} /> : '—'}</div>
//         </div>
//         <div className="card">
//           <div className="stat-label">Package</div>
//           <div className="stat-number" style={{ fontSize: '1.1rem', color: 'var(--color-black)' }}>{profile?.packageName || 'None selected'}</div>
//         </div>
//       </div>

//       <div className="grid grid-2">
//         <div className="card">
//           <h3>Current Cases</h3>
//           {cases.length === 0 ? <p>You have no active cases yet.</p> : (
//             <ul style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//               {cases.slice(0, 5).map((c) => (
//                 <li key={c.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <span>{c.title}</span>
//                   <span className="badge badge-pending">{c.status.replace(/_/g, ' ')}</span>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//         <div className="card">
//           <h3>Recent Messages</h3>
//           {messages.length === 0 ? <p>No messages yet.</p> : (
//             <ul style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//               {messages.slice(-5).reverse().map((m) => (
//                 <li key={m.id}>
//                   <strong>{m.sender === 'MEMBER' ? 'You' : 'Organisation'}:</strong> {m.content.slice(0, 60)}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>
//     </MemberLayout>
//   );
// }


import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyProfile, getMyCases, getMyMessages } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

function StatusBadge({ status }) {
  const cls = status === 'ACTIVE' ? 'badge-active' : status === 'EXPIRED' ? 'badge-expired' : 'badge-pending';
  return <span className={`badge ${cls}`}>{status}</span>;
}

export default function Dashboard() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [cases, setCases] = useState([]);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    getMyProfile().then((res) => setProfile(res.data)).catch(() => {});
    getMyCases().then((res) => setCases(res.data)).catch(() => {});
    getMyMessages().then((res) => setMessages(res.data)).catch(() => {});
  }, []);

  return (
    <MemberLayout>
      <h2>Welcome back, {profile?.fullName || user?.username}</h2>
      <p style={{ marginBottom: 24 }}>Here's an overview of your membership and cases.</p>

      <div className="grid grid-3" style={{ marginBottom: 32 }}>
        <div className="card">
          <div className="stat-label">Membership Number</div>
          <div className="stat-number" style={{ fontSize: '1.4rem' }}>{profile?.membershipNumber || '—'}</div>
        </div>
        <div className="card">
          <div className="stat-label">Status</div>
          <div style={{ marginTop: 8 }}>{profile ? <StatusBadge status={profile.status} /> : '—'}</div>
        </div>
        <div className="card">
          <div className="stat-label">Package</div>
          <div className="stat-number" style={{ fontSize: '1.1rem', color: 'var(--color-black)' }}>{profile?.packageName || 'None selected'}</div>
        </div>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <h3>Current Cases</h3>
          {cases.length === 0 ? <p>You have no active cases yet.</p> : (
            <ul style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {cases.slice(0, 5).map((c) => (
                <li key={c.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{c.title}</span>
                  <span className="badge badge-pending">{c.status.replace(/_/g, ' ')}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="card">
          <h3>Recent Messages</h3>
          {messages.length === 0 ? <p>No messages yet.</p> : (
            <ul style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {messages.slice(-5).reverse().map((m) => (
                <li key={m.id}>
                  <strong>{m.sender === 'MEMBER' ? 'You' : 'Organisation'}:</strong> {m.content.slice(0, 60)}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </MemberLayout>
  );
}
